import review1 from './review-1.png';
import review2 from './review-2.png';
import review3 from './review-3.png';
import review4 from './review-4.png';

export const reviewImages: Record<string, string> = {
  'review-1': review1,
  'review-2': review2,
  'review-3': review3,
  'review-4': review4,
};

export const getReviewImage = (imageName: string): string | undefined => {
  return reviewImages[imageName];
};
